const appendArrayParam = (queryParams, key, value) => {
  if (value === undefined || value === null) return;

  if (Array.isArray(value)) {
    value.forEach((item) => {
      if (item !== undefined && item !== null && item !== '') {
        queryParams.append(key, String(item));
      }
    });
    return;
  }

  queryParams.append(key, String(value));
};

/**
 * @typedef {{
 *  job_titles?: string[] | string,
 *  job_types?: string[] | string,
 *  employment_types?: string[] | string,
 *  auto_apply_filter?: boolean,
 *  salary_filter?: boolean,
 *  jobs_statuses?: string[] | string,
 *  location_country?: string,
 *  location_region?: string,
 *  location_city?: string,
 *  seniority?: string[] | string,
 * }} JobMatchFilters
 */

/**
 * @param {{
 *  status?: string,
 *  page?: number,
 *  limit?: number,
 *  query?: string,
 *  filters?: JobMatchFilters
 * }} params
 */
export const buildJobMatchQueryParams = ({ status, page = 1, limit = 20, query = '', filters = {} } = {}) => {
  const queryParams = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });

  if (status !== undefined && status !== null && status !== '') {
    queryParams.set('status', String(status));
  }

  if (query !== undefined && query !== null && query !== '') {
    queryParams.set('searchQuery', String(query));
  }

  if (filters.location_country !== undefined && filters.location_country !== null && filters.location_country !== '') {
    queryParams.set('filterLocationCountry', String(filters.location_country));
  }

  if (filters.location_region !== undefined && filters.location_region !== null && filters.location_region !== '') {
    queryParams.set('filterLocationRegion', String(filters.location_region));
  }

  if (filters.location_city !== undefined && filters.location_city !== null && filters.location_city !== '') {
    queryParams.set('filterLocationCity', String(filters.location_city));
  }

  appendArrayParam(queryParams, 'seniority[]', filters.seniority);
  appendArrayParam(queryParams, 'filterJobTitles[]', filters.job_titles);
  appendArrayParam(queryParams, 'filterJobTypes[]', filters.job_types);
  appendArrayParam(queryParams, 'filterEmploymentTypes[]', filters.employment_types);
  appendArrayParam(queryParams, 'statuses[]', filters.jobs_statuses);

  if (filters.auto_apply_filter !== undefined && filters.auto_apply_filter !== null) {
    queryParams.set('filterAutoApply', String(filters.auto_apply_filter));
  }

  if (filters.salary_filter !== undefined && filters.salary_filter !== null) {
    queryParams.set('filterHasSalary', String(filters.salary_filter));
  }

  return queryParams;
};
